export const PerformanceQuestionType = <const>{
  OPEN_QUESTION: 'open_question',
  COMPETENCIES: 'competencies',
  SLIDER: 'slider',
  CONTENT_MODULE: 'content_module',
  TALENT_REVIEW: 'talent_review',
  GOAL: 'goal',
};

export const EPerformanceActivityFilterTypes = <const>{
  ALL: 'all',
  NOTES: 'notes',
  HIGHFIVE: 'highfive',
};
